import { LANGUAGE_CODE } from "consts";

export const ALLOWED_NAME_CHARS_REGEX = /^[a-zA-Z0-9\s\-_.,&()']*$/;
export const MIN_NAME_LENGTH = 3;
export const MAX_NAME_LENGTH = 50;
export const MAX_PROJECTS = 20;
export const SOIL_SIGHT_DEMO_VIDEO_BY_LANGUAGE_CODE: Partial<Record<LANGUAGE_CODE, string>> = {
  [LANGUAGE_CODE.ENGLISH]: "https://vimeo.com/1210127775",
  [LANGUAGE_CODE.GERMAN]: "https://vimeo.com/1207418930",
};
export const TREND_PCT_LIMITS = { min: -80, max: 100 };
/** Rounding step for SoilSight contribution-margin figures; the single source for anything that needs the granularity. */
export const CM_ROUNDING_STEP = 10;
// TODO: KH-991 we use the general app feedback form until the SoilSight form exists.
export const SOIL_SIGHT_FEEDBACK_FORM_URL = process.env.REACT_APP_FEEDBACK_URL;
/** Shared side-drawer width so every SoilSight drawer matches the Refine Inputs one (figma). */
export const SOIL_SIGHT_DRAWER_WIDTH = 1006;
/** Debounce of each scenario-page autosave; names wait longer than settings, crop years longest (most edits). */
export const SOIL_SIGHT_AUTOSAVE_DELAY_MS = { settings: 300, scenarioMeta: 400, cropYears: 500 } as const;

// Passes a flush makes so edits typed while it saves are sent too; capped so constant typing cannot hold a switch forever.
export const SOIL_SIGHT_MAX_FLUSH_PASSES = 3;

// How long saving waits for in-flight saves (e.g. paused while offline) before giving up and reporting the changes as unsaved.
export const SOIL_SIGHT_SAVE_IDLE_TIMEOUT_MS = 15000;

// TODO: re-enable when we have settled on which soc source we want to use; also gates the field-soil fetch.
export const SHOW_SOIL_SIGHT_FIELD_SUMMARY = false;

// TODO(KH-1131): remove with the skip-acquisition-flow flag. Caps how long a direct signup link waits for FeatBit.
export const SOIL_SIGHT_SKIP_FLAG_WAIT_MS = 3000;
